<template>
    <div v-if="data.url" class="flex pb-6 justify-center">
        <iframe loading="lazy" :src="data.url" class="aspect-video w-full max-w-[1280px] rounded-md overflow-hidden"></iframe>
    </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>
